import React from 'react';

import {SelectReact} from 'common/components/select';
import {SelectTheme} from 'common/components/select/constants';
import {Section} from 'common/components/items-menu/types';

export function OverflowControls({items}: {items: Section[]}) {
  return (
    <SelectReact
      theme={SelectTheme.Tertiary}
      sections={items}
      menuWidth={`null`} // adjusts the menu width to hug content
      neverShowCaret
      iconOnly
      icon={{leftIcon: `ellipsis`}}
    />
  );
}
